// src/components/NewsDetail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Typography, Box, Button, Divider } from '@mui/material';
import { fetchNewsDetail } from '../lib/api';


const NewsDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getNewsDetail = async () => {
      try {
        const data = await fetchNewsDetail(id);
        setArticle(data);
      } catch (error) {
        console.error("記事の取得に失敗しました:", error);
      } finally {
        setLoading(false);
      }
    };
    getNewsDetail();
  }, [id]);

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center', backgroundColor: "#F5F5F7", minHeight: "100vh" }}>
        <Typography variant="body1">記事を読み込み中...</Typography>
      </Container>
    );
  }

  if (!article) {
    return (
      <Container sx={{ py: 4, textAlign: 'center', backgroundColor: "#F5F5F7", minHeight: "100vh" }}>
        <Typography variant="h5">記事が見つかりませんでした。</Typography>
        <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
          ニュース一覧に戻る
        </Button>
      </Container>
    );
  }

  const formattedDate = article.created_at ? new Date(article.created_at).toISOString().split("T")[0]: "";

  return (
    <Container sx={{ py: 4, backgroundColor: "#F5F5F7", minHeight: "100vh", display: "flex", justifyContent: "center" }}>
      <Box sx={{ backgroundColor: "white", p: 4, borderRadius: 2, boxShadow: 3, maxWidth: "800px", width: "100%" }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {article.TITLE}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {formattedDate}
        </Typography>

        <Divider sx={{ my: 2 }} />

        {[1, 2, 3].map((num) => {
          const headline = article[`HEADLINE${num}`];
          const body = article[`HEADLINE${num}_BODY`];

          return headline && body ? (
            <Box key={num} sx={{ mt: 3 }}>
              <Typography variant="h6" fontWeight="bold">
                {headline}
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {body}
              </Typography>
            </Box>
          ) : null;
        })}

        {/* 引用元 */}
        {article.URL && (
          <>
            <Typography variant="body1" sx={{ mt: 6, whiteSpace: "pre-line" }}>
              {"\n\n"}【参照{" "}{article.SITE_NAME}】:
              <a href={article.URL} target="_blank" rel="noopener noreferrer">
                {article.RAW_TITLE}
              </a>
            </Typography>
          </>
        )}

        <Box sx={{ mt: 4 }}>
          <Button component={Link} to="/" variant="contained">
            ニュース一覧に戻る
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NewsDetail;
